
export const sFechaPublicacion = '2024-06-07T12:42:47.1161872-06:00';
export const sVersion = 'vAppComedor0.1.06071242';
            